import { render, staticRenderFns } from "./visual-config.vue?vue&type=template&id=f57937e4&scoped=true"
import script from "./visual-config.vue?vue&type=script&lang=js"
export * from "./visual-config.vue?vue&type=script&lang=js"
import style0 from "./visual-config.vue?vue&type=style&index=0&id=f57937e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57937e4",
  null
  
)

export default component.exports